import {ChangeDetectorRef, AfterViewInit, Component, ElementRef, HostListener, Input, OnChanges, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { AppState } from '../app.service';
import { Platform } from '@ionic/angular';
import { Reflection } from '../my-library/full-screen-reflection/reflection.model';
import { User } from '../user/user.model';
import { Path } from '../path/path-v2.model';
import { ReflectionService } from '../my-library/full-screen-reflection/reflection.service';
import { ToasterService } from '../toaster.service';
import mixpanel from 'mixpanel-browser';
import { CordovaService } from '../cordova.service';
import { SessionService } from '../session/session.service';
import { HomeUiService } from '../new-design/home-ui.service';
import { I18n } from '../i18n.service';
import { Keyboard } from "@awesome-cordova-plugins/keyboard/ngx";
import { animate, query, stagger, style, transition, trigger } from '@angular/animations';


@Component({
  selector: 'first90-reflection',
  templateUrl: './reflection.component.html',
  styleUrls: ['./reflection.component.scss'],
   animations: [
    trigger('animateContent', [
      transition(':enter', [
        query(':scope > *', [
          style({ opacity: 0, transform: 'translateY(8px)' })
        ], { optional: true }),

        query(':scope > *', [
          stagger(100, [
            animate(
              '800ms cubic-bezier(0.76, 0, 0.24, 1)',
              style({ opacity: 1, transform: 'translateY(0)' })
            )
          ])
        ], { optional: true })
      ]),

      transition(':leave', [
        animate(
          '0.3s cubic-bezier(0.76, 0, 0.24, 1)',
          style({ opacity: 0, transform: 'translateY(-75px)' })
        )
      ])
    ])
  ]
})
export class ReflectionComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('disableListener') disableListener: ElementRef
  @ViewChild('promptRefMobile') promptRefMobile!: ElementRef;
  @ViewChild('promptRefDesktop') promptRefDesktop!: ElementRef;
  innerPromptHtml: any;
  @Input() reflection
  @Input() currentDay: number
  reflectionAnswer: string
  currentUser: User
  currentPath: Path
  savedReflection: string
  isMobile: boolean
  @ViewChild('textareaElement', { static: false }) textareaElement: ElementRef;
  @ViewChild('textAreaContainer', { static: false }) textAreaContainer: ElementRef;
  showMenu = false;
  isEdit = false;
  isMobileWebIos = false;
  isMobileWeb=false;
  hideActionButtons = false;
  @Input() progressItems = [];
  @Input() currentIndex = 0;
  @Input() screenId: any;
  
  constructor(private appState: AppState,
    private reflectionService: ReflectionService,
    private toasterService: ToasterService,
    private renderer: Renderer2,
    private i18n: I18n,
    private cordovaService: CordovaService,
    private sessionService: SessionService,
    private platform: Platform,
    public homeUIService: HomeUiService,
    public keyboard: Keyboard,
    private cdRef: ChangeDetectorRef,
    private _sanitizer: DomSanitizer) {
      this.currentUser = this.appState.get('currentUser')
      this.currentPath = this.appState.get('currentPath')
      this.isMobile = this.appState.get('isMobile')
   }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['reflection']) {
      this.innerPromptHtml = this._sanitizer.bypassSecurityTrustHtml(this.reflection?.screen?.content?.prompt ?? '');
    }
  }

  ngAfterViewInit() {
    if(!this.reflection?.screen?.userResponse?.reflectionText){
      this.appState.set('textareaElement', this.textareaElement)
      this.appState.set('textAreaContainer', this.textAreaContainer)
    }
  }

  ngOnInit() {
    this.isMobileWeb = this.appState.get('MobileWeb')
    this.isMobileWebIos = this.appState.get('MobileWebIos');
    this.resizeHeight();
    this.restoreResizeHeight();
    console.log("this.isMobileWeb value", this.isMobileWeb);
    this.savedReflection = localStorage.getItem(
      `Reflection:User:${this.currentUser.id}:DayProgress:${this.currentPath.id}:${this.currentDay}`
    )
  }

  resizeHeight(){
    this.keyboard.onKeyboardDidShow().subscribe((info) => {
         const mobileLoginScreens = document.querySelector('.card.reflection-min-height');
         if(this.platform.is('android')) {
          mobileLoginScreens?.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px - 50px); min-height: unset`);
         }
         if(this.platform.is('ios')) {
          mobileLoginScreens?.setAttribute('style', `height: calc(100vh - ${info.keyboardHeight}px); min-height: unset`);
         }
         
       });
  }

  restoreResizeHeight(){
    this.keyboard.onKeyboardDidHide().subscribe(() => {
      const mobileLoginScreens = document.querySelector('.card.reflection-min-height');
      mobileLoginScreens?.setAttribute('style', `min-height: 530px`);
    })
  }

  toggleTheme() {
    this.homeUIService.toggleTheme();
    this.cdRef.detectChanges(); 
  }
  findForCurrentDay(collection: any): any {
    return collection.find(
      item => item.startDay <= this.currentDay && this.currentDay <= item.endDay
    )
  }
  extractTextFromHTML(htmlResponse: string): string {
    const tempElement = this.renderer.createElement('div');
    tempElement.innerHTML = htmlResponse;
    return tempElement.textContent
  }

  postAnswer(){
    let dailyStepsArray = this.appState.get('DailyStepsData')
    this.textareaElement.nativeElement.style.setProperty(
      'color',
      `#808080`
    );
    try {
      const requestData = {
        step_id: this.reflection?.stepId,
        screen_id: this.reflection?.screenId,
        screen_content_id: this.reflection?.screenContentId,
        reflection_text: this.reflectionAnswer
      }

      if (!this.reflectionAnswer) {
        this.toasterService.warning(this.i18n.t('Please enter a comment'))
      } else {
        this.reflectionService.saveReflectionAnswerForKyper(requestData).subscribe(
          (response) => {
            this.isEdit = false
            this.savedReflection = response.data.reflectionText
            this.reflectionAnswer = ""
            // Reflect completion on the shared screen object so a mandatory Reflection
            // screen's Next button re-enables live (mirrors poll/survey/question children).
            if (this.reflection?.screen) {
              this.reflection.screen.isCompleted = true
              this.reflection.screen.userResponse = {
                ...(this.reflection.screen.userResponse || {}),
                reflectionText: response.data.reflectionText
              }
              // Persist into DailyStepsData + currentPath so completion survives an in-step
              // close/reopen (which re-derives step data from currentPath) without a refresh.
              this.appState.persistScreenContent(
                { isCompleted: true, userResponse: this.reflection.screen.userResponse },
                { screenContentId: this.reflection?.screenContentId }
              )
            }
            // let promptData = dailyStepsArray[this.currentDay-1].reflections
            // let modifiedPromptData = this.extractTextFromHTML(promptData.prompt)
            mixpanel.track('In Steps-Reflection Post', {'screenContentId': response.data.screen_content_id, 'pathId': response.data.path_id, 'post-text': response.data.reflection_text, 'reflection-screen-id': response.data.screen_id, 'user-id': response.data.user_id})
            localStorage.setItem(
              `Reflection:User:${this.currentUser.id}:DayProgress:${this.currentPath.id}:${this.currentDay}`,response.data.reflectionText
            )
          },
          (error) => {
            console.log('saveReflectionAnswer error :', error);
            this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
          }
        )       
      }

    } catch (o_O) {
      console.log(o_O);
    }
  }

  editAnswer(){
    this.isEdit = true
    this.hideActionButtons = false
    this.onTypingStarted()
    setTimeout(() => {
      this.appState.set('textareaElement', this.textareaElement)
      this.appState.set('textAreaContainer', this.textAreaContainer)
    }, 10);
    if (this.savedReflection) {
      this.reflectionAnswer = this.savedReflection
    } else {
      this.reflectionAnswer = this.reflection.screen?.userResponse?.reflectionText 
    }
  }

  @HostListener('click', ['$event'])
  onLinkClick(e) {
    if (e.target.tagName.toLowerCase() === 'a' && e.target.target === '_blank') {
      if (this.cordovaService.onCordova) {
        e.stopPropagation()
        e.preventDefault()
        this.cordovaService.openLinkInBrowser(e.target.href)
      } else {
        window.open(e.target.href, '_blank')
      }
    }
  }

  onTypingStarted(){
    setTimeout(() => {
      this.textareaElement.nativeElement.classList.add('text-area-expansion')
    }, 10);
  }

  onTextAreaClick(){
    this.hideActionButtons = false
    this.textareaElement.nativeElement.classList.add('text-area-expansion')
  }

  cancel(){
    this.hideActionButtons = true
    setTimeout(() => {
      this.textareaElement.nativeElement.blur()
    }, 10);
    this.textareaElement.nativeElement.classList.remove('text-area-expansion')
    this.isEdit = false
  }
  changeSubTextFont(): null {
    if (this.promptRefMobile?.nativeElement) {
      this.applyStylesToAllInnerTags(this.promptRefMobile.nativeElement);
    }
    if (this.promptRefDesktop?.nativeElement) {
      this.applyStylesToAllInnerTags(this.promptRefDesktop.nativeElement);
    }
    return null;
  }

  applyStylesToAllInnerTags(element: HTMLElement) {
    if (!element) { return; }
    const childElements = Array.from(element.children);
    childElements.forEach((childElement: Element) => {
      const tagName = childElement.tagName.toLowerCase();
      if (tagName === 'ol' || tagName === 'ul') {
        this.renderer.setStyle(childElement, 'list-style', 'none');
        this.renderer.setStyle(childElement, 'padding-left', '1.5em');
      }
      if (tagName === 'li') {
        const dataList = childElement.getAttribute('data-list');
        const qlUi = childElement.querySelector('.ql-ui');
        if (qlUi) { this.renderer.setStyle(qlUi, 'display', 'none'); }
        if (dataList === 'bullet') {
          this.renderer.setStyle(childElement, 'list-style-type', 'disc');
          this.renderer.setStyle(childElement, 'display', 'list-item');
          this.renderer.setStyle(childElement, 'margin-left', '1em');
        } else if (dataList === 'ordered') {
          this.renderer.setStyle(childElement, 'list-style-type', 'decimal');
          this.renderer.setStyle(childElement, 'display', 'list-item');
          this.renderer.setStyle(childElement, 'margin-left', '1em');
        }
      }
      this.applyStylesToAllInnerTags(childElement as HTMLElement);
    });
  }

@HostListener('document:click', ['$event'])
  clickout(event) {
    if(this.disableListener?.nativeElement.contains(event.target)) {
      this.showMenu = !this.showMenu;
    }
    else {
      this.showMenu =false;
    }
  }
}
